import { render } from "./gq.vue?vue&type=template&id=51213efe&scoped=true"
import script from "./gq.vue?vue&type=script&lang=js"
export * from "./gq.vue?vue&type=script&lang=js"

import "./gq.vue?vue&type=style&index=0&id=51213efe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51213efe"]])

export default __exports__